import type { ApiError } from "@circle-react/config/CustomErrors";
import { useEffect, useState } from "react";
import { useMutation } from "react-query";

import { t } from "@/i18n-js/instance";
import type { OptionsType } from "@/react/helpers/backendRequestHelpers";
import { fetchRequest } from "@/react/helpers/backendRequestHelpers";

interface CreateLoginTokenResponse {
  login_url: string;
  token: string | null;
}

const createLoginToken = ({ ...fetchRequestOptions }: Partial<OptionsType>) =>
  fetchRequest<Response>("/internal_api/discover_login_tokens", {
    method: "POST",
    ...fetchRequestOptions,
  });

export const useCreateLoginToken = ({
  onSuccess,
}: {
  onSuccess: (data: CreateLoginTokenResponse) => void;
}) =>
  useMutation<CreateLoginTokenResponse, ApiError>({
    mutationFn: () =>
      createLoginToken({}).then(
        response => response?.json() as Promise<CreateLoginTokenResponse>,
      ),
    onSuccess: onSuccess,
  });

const DiscoverComponent = () => {
  const [loginUrl, setLoginUrl] = useState<string | null>(null);
  const { mutate: createLoginToken } = useCreateLoginToken({
    onSuccess: data => setLoginUrl(data.login_url),
  });

  useEffect(() => {
    createLoginToken();
  }, []);

  if (!loginUrl) return null;

  return (
    <iframe
      title={t("discover.iframe_title")}
      src={loginUrl}
      allow="clipboard-write"
      className="h-[100vh] w-full border-none"
      loading="lazy"
    />
  );
};

export default DiscoverComponent;
